'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthenticationPolicySection } from '@/features/identity-policy';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/idp/_layout/settings/authentication-method/')({
  component: IdpAuthenticationMethodPage
});
function IdpAuthenticationMethodPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.idp.settings.authenticationMethod'
  });
  return <AuthenticationPolicySection title={t('title')} description={t('description')} />;
}